import React from 'react'
import { CardWrapper } from './styles'
import { Text } from '../../styles/Components'
import { gsColors as c } from '../../styles/Variables'

const Card = ({ item, selectedPackage, select }) => {
  const { name, price, discountLabel, prepaidRenewalPeriods } = item
  const handleClick = () => {
    select(item)
  }

  return (
    <CardWrapper onClick={handleClick}>
      <div className={`card-container ${selectedPackage && selectedPackage.id === item.id ? 'selected' : ''}`}>
        <div className='card-content'>
          <Text variant='medium' weight={600}>{name}</Text>
          <Text variant='medium'>${price}</Text>
        </div>

        <div className='card-footer'>
          <Text fontSize={18} color={c.cobalt} weight={600} margin='0 0 10px 0'>{discountLabel}</Text>
          <Text fontSize={13} color={c.meredithGrey} lineHeight='18px'>Renews at $109/mo after {prepaidRenewalPeriods + 1} months</Text>
        </div>
      </div>
    </CardWrapper>
  )
}

export default Card
